<div class="form-group">
    <label for="directionControlSelect">Direction</label>
    <select class="form-control" id="directionControlSelect" (change)="onDirectionChange($event.target.value)">
      <option *ngFor="let direction of directions" [selected]="direction['Direction']== selected_direction" [value]="direction['Direction']" [innerHTML]="direction.DirectionDescription"></option>
    </select>
  </div>